import React, { useEffect, useState } from "react";
import { Row, ListGroup, Form } from "react-bootstrap";
import { Rating } from "react-simple-star-rating";
import "./ProductsPage.css";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import CardchangePage from "../../modal/components/CardchangePage";
import { toast } from "react-toastify";
import emptycartimg from "./../../../assets/emptycart.svg";
import { maintainCartdata } from "../../home/redux/actions";
import no_product from "../../../assets/no_product.svg";
import SelectdeliveryPage from "../../shoppingcard/components/SelectdeliveryPage";
import LoaderPage from "../../loader/components/LoaderPage";
import CoupanPage from "../../modal/components/CoupanPage";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {
  MAGNIFY,
} from "../../comman/components/CommonimagePath";
import { getRequestcall } from "../../comman/util/getRequest";
import {
  ADD_PRODUCT_CART,
  CART_DETAIL,
  CART_ITEM_DELETE,
  PRODUCT_LIST,
  WISH, 
  WISH_REMOVE,
} from "../../constants/apiurl";
import { postRequestcall } from "../../comman/util/postRequest";
import PaginationPage from "../../comman/components/PaginationPage";
import { CurrentorderlistPage,OrdersummaryPage } from "../../comman/components/CurrentorderlistPage";
import ButtonPage from "../../comman/button/ButtonPage";
import MultiRangeSlider from "../../comman/components/MultiRangeSlider";
import SearchProductPage from "../../comman/components/SearchProductPage";
const ProductCommonPage = React.lazy(() =>
  import("../../comman/components/ProductCommonPage")
);
function ProductsPage(props) {
  let storeId = window.location.pathname.split("/").pop();
  let mobileView = window.innerWidth <= 991 ? true: false;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [noproducts, setNoproducts] = useState(false);
  const [category, setCategory] = useState([]);
  const [productlist, setProductlist] = useState([]);
  //const [searchProduct, setSearchproduct] = useState("");
  const [categoryId, setCategoryid] = useState("");
  const [noCart, setNocart] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showdelivery, setShowdelivery] = useState(false);
  const [showcoupon, setShowcoupon] = useState(false);
  let ratingStar = [
    {
      initialValue: 5,
    },
    {
      initialValue: 4,
    },
    {
      initialValue: 3,
    },
    {
      initialValue: 2,
    },
    {
      initialValue: 1,
    },
  ];
  // Rating
  const [rating, setRating] = useState();
  // Cart clear
  const [cartclear, setCartclear] = useState(false);
  const [paginationvalue, setPaginationvalue] = useState({
    totalRecords: 1,
    currentPage: 1,
    from: 0,
    to: 0,
  });
  const [cartInformation, setCartinformation] = useState({
    cart_store_name: "",
    current_store_name: "",
    store_id: "",
  });
  // show variation
  const [price, setprice] = useState([5, 1000]);
  let productfilter = {
    service_id: "",
    page: 1,
    cardDetail: true,
    minprice: "",
    maxprice: "",
    rating: "",
  };
  const [storelocation, setStorelocation] = useState({
    store_lat: "",
    store_lng: "",
  });
  const [productId, setProductid] = useState("");
  const [selectedCategory, setSelectedcategory] = useState("");
  const [links, setLinks] = useState([]);
  const [searchProduct, setSearchproduct] = useState("");

  // eslint-disable-next-line
  useEffect(() => {
    (async () => getProductlist(productfilter))();
    (async () => getCategorylist())();
    // eslint-disable-next-line
  }, []);

  const getProductlist = async (productfilter) => {
    setLoader(true);
    let geturl =
      PRODUCT_LIST +
      `/v2?store_id=${storeId}&page=${productfilter?.page}&service_id=${productfilter?.service_id}&minprice=${productfilter?.minprice}&maxprice=${productfilter?.maxprice}&rating=${productfilter?.rating}&for_users=yes`;
    let getProductlist = await getRequestcall(geturl, props?.access_token);
    if (getProductlist?.status === 200) {
      let list = await getProductlist.json();
      if (list?.data?.productList?.data?.length === 0) {
        if (productfilter?.cardDetail === true) {
          callCardDetail(list);
        }
        setProductlist([]);
        setNoproducts(true);
      } else {
        let productList = [];
        let product = {};
        if (productfilter?.cardDetail === true) {
          callCardDetail(list);
        }
        list?.data?.productList?.data?.forEach((item) => {
          let getVariation = item?.variations.map((item) => {
            return {
              label: `${item?.quantity} ${item?.unit}`,
              value: item?.unit,
              label_tr: `${item?.quantity} ${item?.unit_in_tr}`,
            };
          });
          product = {
            description: item?.description,
            description_in_tr: item?.description_in_tr,
            images: item?.images,
            img_url: item?.img_url,
            pid: item?.pid,
            service_id: item?.service_id,
            service_name: item?.service_name,
            title: item?.title,
            title_in_tr: item?.title_in_tr,
            rating_ratio: item?.rating_ratio,
            total_rating: item?.total_rating,
            variations: item?.variations,
            price: item?.variations[0]?.price,
            discount: item?.variations[0]?.discount,
            current_vid: item?.variations[0]?.vid,
            cart_detail: item?.variations[0]?.cart_detail,
            out_of_stock: item?.variations[0]?.out_of_stock,
            store_id: storeId,
            store_name: list?.data?.store?.title,
            vatrate: item?.vatrate,
            bookmark: item?.bookmark,
            bookmark_id: item?.bookmark_id,
            getVariation: getVariation,
          };
          if (!props.access_token) {
            let getProduct = props?.cartdata?.filter(
              (item) => item?.variation_id === product?.current_vid
            );
            if (getProduct?.length > 0) {
              product?.variations.forEach((item, index) => {
                if (item.vid === getProduct[0]?.variation_id) {
                  product.variations[index].cart_detail =
                    getProduct[0]?.cart_detail; // update variation cart_detail
                  product.cart_detail = getProduct[0]?.cart_detail; // update product cart detail
                }
              });
            }
          }
          productList.push(product);
        });
        setProductlist(productList);
        setLinks(list?.data?.productList?.links);
        setPaginationvalue({
          totalRecords: list?.data?.productList?.total,
          currentPage: productfilter?.page,
          from: list?.data?.productList?.from,
          to: list?.data?.productList?.to,
        });
        // set current store id
        setCategoryid(productfilter?.service_id);
        setNoproducts(false);
      }
    } else if (getProductlist?.status === 500) {
      toast.error(t("pages.internal"));
    }
    setLoader(false);
  };

  const getCategorylist = () => {
    let categoryObj = {};
    let categoryArray = [];
    let service_id = props?.storedetail?.service_id?.split(",");
    service_id?.forEach((id) => {
      const getCategory = props?.categories?.filter((item) => item?.id === id);
      if (getCategory.length > 0) {
        categoryObj = {
          id: getCategory[0].id,
          title: getCategory[0].title,
        };
        categoryArray.push(categoryObj);
      }
    });
    //getting category id and tilte
    setCategory(categoryArray);
  };

  const callCardDetail = async (list) => {
    if (props.access_token) {
      setCartinformation({
        cart_store_name: list?.data?.cart_detail?.store_name,
        current_store_name: list?.data?.store?.title,
        store_id:
          list?.data?.cart_detail?.store_id === null
            ? ""
            : list?.data?.cart_detail?.store_id,
      });
      let getCartdetailapiresponse = await getRequestcall(
        CART_DETAIL + `?lang=${props?.language?.toLowerCase()}`,
        props?.access_token
      );
      if (getCartdetailapiresponse?.status === 200) {
        let getRes = await getCartdetailapiresponse.json();
        getCartlist(getRes?.data?.cart_products, false);
      }
      else if(getCartdetailapiresponse?.status === 400) {
        emptyCart();
      }
    } else {
      if (props?.cartdata?.length === 0) {
        setCartinformation({
          cart_store_name: "",
          current_store_name: "",
          store_id: "",
        });
      } else {
        setCartinformation({
          cart_store_name: props?.cartdata[0]?.store_name, // take it from props.cartdata redux
          current_store_name: list?.data?.store?.title,
          store_id: props?.cartdata[0]?.store_id,
        });
      }
      getCartlist(props?.cartdata, false); // before login current order list
    }
  };

  // Add to cart

  const addtoCart = async (e, pid) => {
    e?.stopPropagation();
    if (
      cartInformation?.store_id !== storeId &&
      cartInformation?.store_id !== ""
    ) {
      setProductid(pid);
      setCartclear(true);
    } else {
      addProducttocart(pid);
    }
  };

  const addProducttocart = async (pid) => {
    let id = "";
    let quantity = 1;
    let getProduct = productlist.filter((item) => item.pid === pid);
    if (getProduct.length > 0) {
      if (props.access_token) {
        // If user is login
        let geturl =
          ADD_PRODUCT_CART +
          `?store_id=${storeId}&product_id=${pid}&variation_id=${getProduct[0]?.current_vid}&quantity=${quantity}&id=${id}`;
        let getCartapiresponse = await postRequestcall(
          geturl,
          props?.access_token,
          ""
        );
        if (getCartapiresponse?.status === 200) {
          let getId = await getCartapiresponse.json();
          getId = getId?.data;
          storeCartProducts(productlist, getId, getProduct, quantity);
        }
      } else {
        storeCartProducts(productlist, "", getProduct, quantity);
      }
    }
  };

  const quantityPlus = async (e, pid, get_cart_detail) => {
    e.stopPropagation();
    let check_stock = true;
    let getid = get_cart_detail?.id;
    let updated_id;
    let quantity = get_cart_detail?.quantity;
    let getProduct = productlist.filter((item) => item.pid === pid);
    if (getProduct?.length > 0) {
      let getVariation = getProduct[0]?.variations.filter(
        (item) => item?.vid === getProduct[0]?.current_vid
      );
      if (getVariation?.length !== 0) {
        if (getVariation[0]?.is_stock === "yes") {
          if (quantity + 1 > getVariation[0]?.stock) {
            check_stock = false;
            toast.error(t('pages.Out of Stock'))
            // toast.error(
            //   t("pages.You can not add more than") +
            //     " " +
            //     getVariation[0]?.stock +
            //     " " +
            //     t("pages.quantities of this product")
            // );
          }
        } else {
          check_stock = true;
        }
        if (check_stock === true) {
          if (getProduct.length > 0) {
            if (props?.access_token) {
              let geturl =
                ADD_PRODUCT_CART +
                `?store_id=${storeId}&product_id=${pid}&variation_id=${
                  getProduct[0]?.current_vid
                }&quantity=${quantity + 1}&id=${getid}`;
              let getResponse = await postRequestcall(
                geturl,
                props?.access_token,
                ""
              );
              if (getResponse?.status === 200) {
                let id = await getResponse.json();
                updated_id = id.data;
                storeCartProducts(
                  productlist,
                  updated_id,
                  getProduct,
                  quantity + 1
                );
              }
            } else {
              storeCartProducts(productlist, "", getProduct, quantity + 1);
            }
          }
        }
      }
    }
  };

  const quantityMinus = async (e, pid, get_cart_detail) => {
    e.stopPropagation();
    let getid = get_cart_detail?.id;
    let updated_id;
    let quantity = get_cart_detail?.quantity;
    let getResponse;
    let getProduct = productlist.filter((item) => item.pid === pid);
    if (getProduct.length > 0) {
      if (props.access_token) {
        if (get_cart_detail?.quantity === 1) {
          let geturl = CART_ITEM_DELETE + `?id=${getid}`;
          getResponse = await postRequestcall(geturl, props?.access_token, "");
        } else {
          let geturl =
            ADD_PRODUCT_CART +
            `?store_id=${storeId}&product_id=${pid}&variation_id=${
              getProduct[0]?.current_vid
            }&quantity=${quantity - 1}&id=${getid}`;
          getResponse = await postRequestcall(geturl, props?.access_token, "");
        }
        if (getResponse?.status === 200) {
          if (get_cart_detail?.quantity === 1) {
            storeCartProducts(productlist, "", getProduct, null);
          } else {
            let id = await getResponse.json();
            updated_id = id?.data;
            storeCartProducts(
              productlist,
              updated_id,
              getProduct,
              quantity - 1
            );
          }
        }
      } else {
        if (get_cart_detail?.quantity === 1) {
          storeCartProducts(productlist, "", getProduct, null);
        } else {
          storeCartProducts(productlist, "", getProduct, quantity - 1);
        }
      }
    }
  };

  // For Before and after login maintain cart products
  const storeCartProducts = (productlist, id, getProduct, quantity) => {
    let productList = [];
    let cart_detail = {};
    let currentProduct = {};
    productlist.forEach((item, index) => {
      if (item.pid === getProduct[0]?.pid) {
        item.variations.forEach((item) => {
          // cart_detail id and quantity updated
          if (item.vid === getProduct[0].current_vid) {
            cart_detail =
              quantity === null ? null : { id: id, quantity: quantity };
            item.cart_detail = cart_detail;
          }
        });
        let getValue = item.variations.filter(
          (item) => item.vid === getProduct[0].current_vid
        );
        productlist[index].cart_detail = getValue[0]?.cart_detail;
        productList.push(productlist[index]);
        currentProduct = productlist[index];
      } else {
        productList.push(productlist[index]);
      }
    });
    setProductlist(productList);
    filterCurrentorder(currentProduct);
  };

  // Filter current order list update and add
  const filterCurrentorder = (product) => {
    let flag = true;
    let getProduct = props?.cartdata?.filter(
      (item) => item.variation_id === product?.variations[0]?.vid
    );
    let productObj = {
      cart_detail: product?.variations[0]?.cart_detail,
      id: product?.variations[0]?.cart_detail?.id,
      store_id: product?.store_id,
      store_name: product?.store_name,
      product_id: product?.pid,
      variation_id: product?.variations[0]?.vid,
      quantity: product?.variations[0]?.cart_detail?.quantity,
      title_in_tr: product?.title_in_tr,
      product_name: product?.title,
      product_deleted_at: null,
      images: product?.images,
      img_url: product?.img_url,
      is_stock: product?.variations[0]?.is_stock,
      stock: product?.variations[0]?.stock,
      price: product?.variations[0]?.price,
      discount: product?.variations[0]?.discount,
      product_qty: product?.variations[0]?.quantity,
      unit_name: product?.variations[0]?.unit,
      unit_id: product?.variations[0]?.unit_id,
      variation_deleted_at: null,
      out_of_stock: product?.variations[0]?.out_of_stock,
      vatrate: product?.vatrate,
    };
    if (getProduct?.length !== 0) {
      props?.cartdata?.forEach((item, index) => {
        if (item.variation_id === product?.variations[0]?.vid) {
          if (product?.variations[0]?.cart_detail === null) {
            flag = false;
          } else {
            props.cartdata[index] = productObj; // update
          }
        }
      });
    } else {
      if (product?.variations[0]?.cart_detail === null) {
        // First time if redux does not contain value and when we minus the quantity
        flag = false;
      } else {
        props?.cartdata.push(productObj); // add
      }
    }
    if (flag === false) {
      let getCart = props?.cartdata?.filter(
        (item) => item.variation_id !== product?.variations[0]?.vid
      );
      getCartlist(getCart, true);
    } else {
      getCartlist(props?.cartdata, true);
    }
  };

  const getCartlist = (cartdata, totalAmtchange) => {
    let total_amount = 0;
    let final_vat_rate = 0;
    let final_sub_total = 0;
    if (cartdata?.length !== 0) {
      cartdata?.forEach((product) => {
        if (
          product?.product_deleted_at === null &&
          product?.out_of_stock === false &&
          product?.variation_deleted_at === null
        ) {
          let productPrice = 0;
          let vat_rate = 0;
          let sub_total = 0;
          if (
            product?.discount !== null &&
            product?.discount !== 0 &&
            product?.discount < product?.price
          ) {
            productPrice = product?.discount * product?.quantity;
          } else {
            productPrice = product?.price * product?.quantity;
          }
          if (
            typeof product.vatrate === "undefined" ||
            product.vatrate === null
          ) {
            sub_total = productPrice;
          } else {
            sub_total = productPrice / (product.vatrate / 100 + 1);
            vat_rate = productPrice - sub_total;
            final_vat_rate = final_vat_rate + vat_rate;
          }
          final_sub_total = final_sub_total + sub_total;
          total_amount = total_amount + productPrice;
        }
      });
      // Developer comment :: If user apply coupon or delivery charges and after that if user add product or minus product then the discount and charges will be zero
      let amount = {
        ...props?.amount,
        sub_total: final_sub_total.toFixed(2),
        vat_rate: final_vat_rate.toFixed(2),
        total_amount: total_amount,
        discount: totalAmtchange === true ? 0 : props?.amount?.discount,
        charges: totalAmtchange === true ? 0 : props?.amount?.charges,
        coupon_code: totalAmtchange === true ? "" : props?.amount?.coupon_code,
        offer_id: totalAmtchange === true ? "" : props?.amount?.offer_id,
      };
      props.maintainCartdata(cartdata, amount); // maintain in redux
      setNocart(false);
    } else {
      emptyCart();
    }
  };

  const emptyCart = () => {
    setNocart(true);
    props.maintainCartdata([], {}); // clear the redux cart
    // Case after clear all the product user can add to cart product
    setCartinformation({
      cart_store_name: "",
      current_store_name: "",
      store_id: "",
    });
  }

  const removeProduct = async (getValue) => {
    if (props?.cartdata?.length > 0) {
      let value = true;
      if (props.access_token) {
        let geturl = CART_ITEM_DELETE + `?id=${getValue?.id}`;
        let getResponse = await postRequestcall(
          geturl,
          props?.access_token,
          ""
        );
        if (getResponse?.status === 200) {
          callCardDetail()
        } else if (getResponse.status === 500) {
          toast.success(t("pages.internal"));
          value = false;
        } else {
          value = false;
        }
      }
      if (value === true) {
        // Refresh the product list
        let getProduct = productlist.filter(
          (item) => item.pid === getValue?.product_id
        );
        if (getProduct.length !== 0) {
          storeCartProducts(productlist, "", getProduct, null);
        } else {
          // When user visit to another store and when remove the product
          let getProduct = props?.cartdata.filter(
            (item) => item.product_id !== getValue?.product_id
          );
          getCartlist(getProduct, true);
        }
      }
    }
  };

  const searchChange = (e) => {
    setSearchproduct(e.target.value);
  };

  const handlePageChange = async (page) => {
    let productfilter = {
      service_id: "",
      page: page,
      cardDetail: false,
      minprice: "",
      maxprice: "",
      rating: "",
    };
    getProductlist(productfilter);
  };

  const navigateToproductdetail = (e, pid) => {
    // Passes the other product list to product detail page
    var timestamp = new Date().getTime();
    navigate(`/product-detail/${pid}`, {
      state: {
        categoryId: categoryId,
        refresh: timestamp,
      },
    });
  };

  const navigteTobilldetail = async (e) => {
    e.preventDefault();
    let getCartdetailapiresponse = await getRequestcall(
      CART_DETAIL+ `?lang=${props?.language?.toLowerCase()}`,
      props?.access_token,
    );
    if (getCartdetailapiresponse?.status === 200) {
      let getRes = await getCartdetailapiresponse.json();
      const OutOfStock = getRes?.data?.cart_products?.filter((item)=>item?.out_of_stock !== false)
      console.log("OutOfStock", OutOfStock)

      if(OutOfStock?.length === 0 && getRes?.data?.cart_products?.length>0){
        if (props?.amount?.total_amount === 0) {
          toast.error(t("pages.Please add product to cart"));
        } else {
          if (props?.cartdata?.length === 0) {
            toast.error(t("pages.Your cart is empty"));
          } else {
            setStorelocation({
              store_lat: props?.storedetail?.lat,
              store_lng: props?.storedetail?.lng,
            });
            setShowdelivery(true);
          }
        }
      }else{
        await getProductlist(productfilter)
        if (getRes?.data?.cart_products?.length > 0) {
          setStorelocation({
            store_lat: getRes?.data?.store_lat,
            store_lng: getRes?.data?.store_lng,
            store_address: getRes?.data?.store_address
          });
          getCartlist(getRes?.data?.cart_products);
        } else {
          emptyCart();
        }
      }
    } else if (getCartdetailapiresponse?.status === 400) {
      let getError = await getCartdetailapiresponse.json();
      toast.error(getError?.errors);
      emptyCart();
    }
    // if (props?.amount?.total_amount === 0) {
    //   toast.error(t("pages.Please add product to cart"));
    // } else {
    //   if (props?.cartdata?.length === 0) {
    //     toast.error(t("pages.Your cart is empty"));
    //   } else {
    //     setStorelocation({
    //       store_lat: props?.storedetail?.lat,
    //       store_lng: props?.storedetail?.lng,
    //     });
    //     setShowdelivery(true);
    //   }
    // }
  };

  // Filter functionality start
  const allCategories = async () => {
    let productfilter = {
      service_id: "",
      page: paginationvalue?.currentPage,
      cardDetail: false,
      minprice: "",
      maxprice: "",
      rating: "",
    };
    getProductlist(productfilter);
    setCategoryid("");
    setSelectedcategory("");
  };

  const selectCategoryServices = async (index) => {
    let getService = category[index];
    //Passing category id and calling product list
    let productfilter = {
      service_id: getService?.id,
      page: paginationvalue?.currentPage,
      cardDetail: false,
      minprice: "",
      maxprice: "",
      rating: "",
    };
    getProductlist(productfilter);
    // set current store id
    setCategoryid(getService?.id);
    setSelectedcategory(index);
  };

  const clearCategory = () => {
    allCategories();
  };

  const priceValueChange = (value) => {
    setprice(value);
  };

  const applyPrice = () => {
    let productfilter = {
      service_id: categoryId,
      page: paginationvalue?.currentPage,
      cardDetail: false,
      minprice: price[0],
      maxprice: price[1],
      rating: "",
    };
    getProductlist(productfilter);
  };

  const priceClear = () => {
    setprice([5, 1000]);
    let productfilter = {
      service_id: categoryId,
      page: paginationvalue?.currentPage,
      cardDetail: false,
      minprice: "",
      maxprice: "",
      rating: "",
    };
    getProductlist(productfilter);
  };

  const selectRating = async (index) => {
    let getStar = ratingStar[index];
    //Passing category id and calling product list
    let productfilter = {
      service_id: categoryId,
      page: paginationvalue?.currentPage,
      cardDetail: false,
      minprice: "",
      maxprice: "",
      rating: getStar?.initialValue,
    };
    getProductlist(productfilter);
    setRating(index);
  };

  const clearRating = () => {
    let productfilter = {
      service_id: categoryId,
      page: paginationvalue?.currentPage,
      cardDetail: false,
      minprice: "",
      maxprice: "",
      rating: "",
    };
    getProductlist(productfilter);
    setRating();
  };

  // Filter functionality end

  // const showVariationModal = (e, index) => {
  //   e?.stopPropagation();
  //   setProductindex(index);
  //   setShowvariation(true);
  // };

  const addorremoveWish = async (e, item) => {
    e.stopPropagation();
    e.preventDefault();
    if (props.access_token) {
      if (item.bookmark === "no") {
        let geturl =
          WISH +
          `?store_id=${item?.store_id}&product_id=${item?.pid}&variation_id=${item?.current_vid}`;
        let getResponse = await postRequestcall(
          geturl,
          props?.access_token,
          ""
        );
        if (getResponse?.status === 200) {
          let addwishResp = await getResponse.json();
          let updateStatus = [];
          productlist.forEach((product) => {
            if (product?.pid === item?.pid) {
              product.bookmark = "yes";
              product.bookmark_id = addwishResp?.data;
            }
            updateStatus.push(product);
          });
          setProductlist(updateStatus);
        }
      } else {
        let geturl = WISH_REMOVE + `?id=${item?.bookmark_id}`;
        let getResponse = await postRequestcall(geturl, props?.access_token);
        if (getResponse?.status === 200) {
          let updateStatus = [];
          productlist.forEach((product) => {
            if (product?.pid === item?.pid) {
              product.bookmark = "no";
              product.bookmark_id = "";
            }
            updateStatus.push(product);
          });
          setProductlist(updateStatus);
        }
      }
    } else {
      toast.error(t("pages.Please login"));
    }
  };

  const openCouponpage = () => {
    if (props.access_token) {
      setShowcoupon(true);
    } else {
      toast.error(t("pages.Please login first"));
    }
  };

  const LabelRender = (getId) => {
    const getTitle = props?.categories?.filter((item) => item?.id === getId.id);
    return <>{getTitle[0]?.title}</>;
  };

  // const unitListrender = (variation) => {
  //   variation = {
  //     label: props.language === "Tr" ? variation?.label_tr : variation?.label,
  //     label_tr: variation?.label_tr,
  //     value: variation?.value,
  //   };
  //   return variation;
  // };

  const searchValuechange = (e) => {
    e.preventDefault();
    setSearchproduct(e.target.value);
  };

  if (loader) return <LoaderPage className={"user-dashboard"} />;

  return (
    <>
      {/* Category logo and current logo */}
      
      <div className="products-content">
        <Row className="product-row">
          {!props?.mobileView && 
          <div
            className="col-sm-12 col-md-12 col-lg-2 col-xl-2 category"
          >
            <div>
              <div className="category-txt pt-4">
                <h5>{t("pages.stores.categories")}</h5>
                <h6 onClick={() => clearCategory()}>
                  {t("pages.stores.clear")}
                </h6>
              </div>
              <ListGroup className="category-list">
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => allCategories()}
                >
                  <ListGroup.Item>
                    {t("pages.storedetail.products.allcategory")}
                    <Form.Check
                      type="checkbox"
                      checked={selectedCategory === "" ? true : false}
                      readOnly
                    />
                  </ListGroup.Item>
                </div>
                {category?.map((item, index) => (
                  <div
                    style={{ cursor: "pointer" }}
                    key={index.toString()}
                    onClick={() => selectCategoryServices(index)}
                  >
                    <ListGroup.Item>
                      <LabelRender id={item?.id} />
                      <Form.Check
                        name={item.title}
                        id={item.id}
                        type="checkbox"
                        checked={selectedCategory === index ? true : false}
                        readOnly
                      />
                    </ListGroup.Item>
                  </div>
                ))}
              </ListGroup>
            </div>
            <div className="category-txt pt-4">
              <h5>{t("pages.storedetail.products.price")}</h5>
              <h6 onClick={() => priceClear()}>{t("pages.stores.clear")}</h6>
              <div className="price-filter">
                <div className="slider-div">
                  <MultiRangeSlider 
                    min={1}
                    max={1000}
                    onChange={({ min, max }) =>
                      priceValueChange([min, max ])
                    }
                  />
                  </div>
                <button className="apply-btn" onClick={() => applyPrice()}>
                  {t("pages.coupan.submit")}
                </button>
              </div>
            </div>
            <div>
              <div className="category-txt pt-4">
                <h5>{t("pages.storedetail.products.rating")}</h5>
                <h6 onClick={() => clearRating()}>{t("pages.stores.clear")}</h6>
              </div>
              <ListGroup className="category-list">
                {ratingStar?.map((item, index) => (
                  <div
                    style={{ cursor: "pointer" }}
                    key={index.toString()}
                    onClick={() => selectRating(index)}
                  >
                    <ListGroup.Item style={{ padding: "5px 0px" }}>
                      <Rating
                        initialValue={item?.initialValue}
                        readonly={true}
                        size={22}
                        fillColor={"var(--pr-color)"}
                      />
                      <Form.Check
                        name={item.title}
                        id={item.id}
                        type="checkbox"
                        checked={rating === index ? true : false}
                        readOnly
                      />
                    </ListGroup.Item>
                  </div>
                ))}
              </ListGroup>
            </div>
          </div>}
          <div
            className="col-sm-12 col-md-12 col-lg-7 col-xl-7 product-list"
          >
            <Row style={{ alignItems: "center" }}>
              {props?.language === "Tr" ? (
                <h6 className="show col-sm-7">
                  {paginationvalue?.totalRecords} {t("pages.stores.results")}{" "}
                  {paginationvalue?.from} - {paginationvalue?.to}{" "}
                  {t("pages.stores.of")} {t("pages.stores.showing")}
                </h6>
              ) : (
                <h6 className="show col-sm-7">
                  {t("pages.stores.showing")} {paginationvalue.from}–
                  {paginationvalue.to} of {paginationvalue.totalRecords}{" "}
                  {t("pages.stores.results")}
                </h6>
              )}
              <div className="col-sm-5 search-product">
                <div className="input-group">
                  <span className="input-group-text">
                    <label htmlFor="searchform" className="search-icon">
                      <img src={MAGNIFY} height="25" width="25" alt="search"></img>
                    </label>
                  </span>
                  <input
                    placeholder={t("pages.storedetail.products.search-place")}
                    id="searchform"
                    value={searchProduct}
                    onChange={(e) => searchChange(e)}
                    className="form-control"
                  />
                </div>
              </div>
            </Row> 
            {mobileView && (
                  <SearchProductPage
                   onChange={searchValuechange}
                  value={searchProduct}
                  placeholder={t("pages.storedetail.products.search-place")}
               />)}
      <div className="category-list-mob">
              <h5 className="category-text">
              {t("pages.stores.categories")}
              </h5>
              <div className="swipper_content">
              {
                <div className={"sidebar-cateloge-slider "}>
                    <div
                      className={selectedCategory === ""?"swipper-text active":"swipper-text"}
                      onClick={() => allCategories()}
                     >
                      {t("pages.storedetail.products.allcategory")}
                    </div>
                    {category?.map((item, index) => (
                    <div
                      className={
                        selectedCategory === index ? 
                        "swipper-text active" : "swipper-text"
                      }
                      onClick={() => selectCategoryServices(index)}
                    >
                     {item.title}
                    </div>
                    ))}
                </div>
              }
            </div>
           </div>
              {noproducts ? (
                <div className="no-product">
                  <LazyLoadImage alt="" src={no_product}></LazyLoadImage>
                  <h5>{t("pages.No products found")}</h5>
                </div>
              ) : productlist.filter((label) => {
                  if (searchProduct === "") {
                    return label;
                  }
                  if (
                    label?.title
                      ?.toLowerCase()
                      .includes(searchProduct?.toLowerCase())
                  ) {
                    return label;
                  }
                  return null;
                }).length === 0 ? (
                searchProduct !== "" ? (
                  <Row>
                    <div className="text-center pt-4">
                      {t("pages.No records found")}
                    </div>
                  </Row>
                ) : (
                  <></>
                )
              ) : (
                <ProductCommonPage
                  navigateToproductdetail={navigateToproductdetail}
                  language={props?.language}
                  addorremoveWish={addorremoveWish}
                  store_id={storeId}
                  quantityMinus={quantityMinus}
                  quantityPlus={quantityPlus}
                  addtoCart={addtoCart}
                  data={productlist}
                  search={searchProduct}
                  className={"Comman_product"} //Comman_product
                  innerClass={"innerProduct"}
                  listClass={"col-sm-12 col-md-12 col-lg-6 col-xl-6"}
                  is_productlist={false}
                  setNocart={setNocart}
                  setProductlist={setProductlist}
                  cartInformation={cartInformation}
                  setCartinformation={setCartinformation}
                  {...props}
                />
              )}
            {noproducts === false && paginationvalue?.totalRecords > 10 && (
              <div className="text-end mb-2">
                <PaginationPage
                  changeCurrentpage={handlePageChange}
                  nopagination={noproducts}
                  links={links}
                />
              </div>
            )}
          </div>
          <div
            className="col-sm-12 col-md-12 col-lg-3 col-xl-3 current-order mt-2"
          >
            {noCart || props?.cartdata?.length === 0 ? (
              <div className="emptycart-div">
                <LazyLoadImage src={emptycartimg} alt=""></LazyLoadImage>
                <h5>{t("pages.Your shopping bag is empty")}</h5>
              </div>
            ) : (
              <>
               <CurrentorderlistPage cartdata={props?.cartdata} removeProduct={removeProduct} close={true}/>
                {props?.cartdata?.length > 0 && (
                  <>
                  <OrdersummaryPage amount={props?.amount}/>
                    <div className="card value mt-2">
                      <div
                        className="card-body"
                        onClick={() => openCouponpage()}
                      >
                        <label
                          className="font-16"
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          {t("pages.coupan_apply")}{" "}
                          <span className="pr-color hover">
                            {t("pages.Click here")}
                          </span>
                        </label>
                      </div>
                    </div>
                    <ButtonPage Text={t("pages.payment_card.checkout")}  onClick={(e) => navigteTobilldetail(e)} className={`button-submit w-100 rounded mt-2`} type={"submit"} /> 
                  </>
                )}
              </>
            )}
          </div>
        </Row>
      </div>
      <CoupanPage showcoupon={showcoupon} setShowcoupon={setShowcoupon} />
      <SelectdeliveryPage
        showdelivery={showdelivery}
        setShowdelivery={setShowdelivery}
        storelocation={storelocation}
      />
      <CardchangePage
        cartclear={cartclear}
        cartInformation={cartInformation}
        setCartinformation={setCartinformation}
        setCartclear={setCartclear}
        addProducttocart={addProducttocart}
        productId={productId}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login?.access_token,
  type: state?.login?.type,
  storeDetail: state?.dashboard?.storeDetail,
  cartdata: state?.home?.cartdata,
  amount: state?.home?.amount,
  language: state?.languageState?.language,
  categories: state?.home.categories,
  jid: state?.login?.jid,
  jpass: state?.login?.jpass,
});

export default connect(mapStateToProps, { maintainCartdata })(ProductsPage);
